export default function workOrderNotesBuilder(builder, payload = {}) {
  const { workOrderNotesById } = payload || {}

  if (!workOrderNotesById) return

  Object.values(workOrderNotesById).forEach(workOrderNoteVersionList => {
    const workOrderNoteVersionListWithDerivedFields = workOrderNoteVersionList.map(version => ({
      ...version,
      pinnedStatus: version.pinned ? 'Pinned' : 'Unpinned',
      archivedStatus: version.archived ? 'Archived' : 'Restored',
    }))
    builder.addChanges(workOrderNoteVersionListWithDerivedFields, {
      entityName: 'Work Order Note',
      fieldConfig: {
        noteText: 'Note',
        pinnedStatus: 'Pinned Status',
        archivedStatus: 'Archived Status',
      },
    })
  })
}
